/**
 * Created by phatbass on 2/9/16.
 */

angular.module('far.search')
    .controller('SearchAlpClubController', function ($log, $http, form, formsUtils, autocomplete) {
        var vm = {
            loaded: true,
            submitted: false,
            includeAll: false,
            form: {},
            current: {
                offset: 0,
                limit: 30,
                count: '',
                data: []
            },
            total: {
                count: 0,
                pages: null
            },
            formSearchClub: form('formSearchClub'),
            submit: function ( next ) {
                if (vm.submitted) {
                    return false;
                }

                if ( !next ) {
                    vm.current.offset = 0;
                    vm.current.data = [];
                    vm.total.count = 0;
                    vm.total.pages = null;
                }

                var data = angular.merge({}, vm.form);
                if(1 > Object.keys(data).length){
                    if('' !== window.location.hash){
                        data = JSON.parse(decodeURIComponent(atob(window.location.hash.substring(1))));
                    }
                }
                this.data = data;
                window.location.hash = btoa(encodeURIComponent(JSON.stringify(data)));

                if ( angular.isObject( data.member ) ) {
                    data.member = data.member.id;
                }

                if ( angular.isObject( data.qualification ) ) {
                    data.qualification = data.qualification.id;
                }

                if ( angular.isObject( data.achievements ) ) {
                    data.achievements = data.achievements.id;
                }

                data['offset'] = vm.current.offset;
                data['limit'] = vm.current.limit;

                data['subclub'] = true;
                vm.submitted = true;

                if (data.city && data.city.name) {
                    data.city = data.city.name;
                }

                if (data.region && data.city.region) {
                    data.region = data.region.name;
                }

                $http.get(Routing.generate('api_club_search', data)).then(function (response) {
                    vm.total.count = response.headers('X-Total-Count');
                    vm.total.pages = Math.ceil( vm.total.count / vm.current.limit );

                    for ( var id in response.data ) {
                        response.data[ id ]['url'] = Routing.generate('club_members', {id: response.data[id].id});

                        if ( response.data[ id ].users.length ) {
                            response.data[ id ].users = response.data[ id ].users.map(function(user) {
                                user['url'] = Routing.generate('user_view', {userId: user.id});

                                return user;
                            });
                        }

                        vm.current.data.push( response.data[ id ] );
                    }

                    vm.current.count = 'Альпинистские клубы России';

                    vm.submitted = false;
                }, function errorCallback(response) {
                    $log.error(response);

                    vm.submitted = false;
                });
            },

            next: function () {
                vm.current.offset += vm.current.limit;
                vm.submit( true );
            },

            getTotalCount: function () {
                return vm.current.count;
            }
        };

        vm.formSearchClub
            .addField('region', 'uiSelect', {
                validators: {
                    required: false
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select width-400 margin_r_20'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Регион',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by $index',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "KladrRegion", "region")',
                        refreshDelay: 400
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete,
                    onSelect: function (item) {
                        if (item) {
                            vm.form.region = item;
                        }
                    }
                },
                fieldData: {
                    name: 'region'
                }
            }, autocomplete.get('region'))
            .addField('city', 'uiSelect', {
                validators: {
                    required: false
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select width-400 margin_r_20'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Город',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by $index',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "KladrCity", "city")',
                        refreshDelay: 400
                    },
                    refreshAutoComplete: function(name, term, object) {
                        var params = {};
                        if (vm.form.region && vm.form.region.id) {
                            params.region = vm.form.region.id;
                        }
                        return autocomplete.refreshAutoComplete(name, term, object, params)
                    },
                    onSelect: function (item) {
                        if (item) {
                            vm.form.city = item;
                        }
                    }
                },
                fieldData: {
                    name: 'city'
                }
            }, autocomplete.get('city'))
        ;

        vm.submit();

        return vm;
    });
